module.exports = __webpack_public_path__ + "c9238d7b0a7ab72a2c6f85b59f45b8fa.svg";